import React, { useEffect,useState } from "react";
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import Button from "olive-react-myoneui/lib/Button";
import CourseEvent from "./courseEvent";
import CourseBundleDescription from "../course-curriculum/CourseBundleDescription";
import striptags from 'striptags';

function CourseEventsListing({courseDetails, selectedTimeZone}) {
  const [bbcDescription, setBbcDescription]               = useState(null);
  const [bbcRefundPolicy, setBbcRefundPolicy]             = useState(null);
  const [bbcCancellationPolicy, setBbcCancellationPolicy] = useState(null);
  const [showSeeMoreDates, setShowSeeMoreDates]           = useState(false);
  const [shownEventsCount, setShownEventsCount]           = useState(0);
  const [maxEventsCount, setMaxEventsCount]               = useState(4);
  const [customSections, setCustomSections]               = useState({});
  const events              = courseDetails?.event_data;
  const eventsCount         = courseDetails?.event_data?.length;
  const currency            = courseDetails?.current_currency;
  const memberPricingLabel  = courseDetails?.member_pricing_label;
  const currentPricingLabel = courseDetails?.current_pricing_label;
  const showMemberPrice     = courseDetails?.show_member_price;
  const isCartEnabled       = courseDetails?.isCartEnabled;
  const currentDateTime     = courseDetails?.current_date_time;

  const seeMoreDates = () => {
    setMaxEventsCount((prev) => ( prev + 4 ));
    let tempMaxEventsCount = maxEventsCount + 4;
    if(eventsCount > tempMaxEventsCount){
      setShowSeeMoreDates(true)
    } else {
      setShowSeeMoreDates(false)
    }
  }

  useEffect(() => {
    if(courseDetails && typeof courseDetails !== 'undefined'){
      if(typeof courseDetails.course !== 'undefined'){
        setBbcDescription(courseDetails.course.bbc_description);
        setBbcRefundPolicy(courseDetails?.course?.bbc_refund_policy);
        setBbcCancellationPolicy(courseDetails?.course?.bbc_cancellation_policy);
        setCustomSections(typeof courseDetails.course.bbc_custom_sections != 'undefined' ? JSON.parse(courseDetails.course.bbc_custom_sections) : {});
      }
      if(events && events.length > 4){
        setShowSeeMoreDates(true);
      }
    }
  },[courseDetails]);

  return (
    <>
      <Row className="events-list-wrapper">
        {
          (typeof events !== 'undefined' && Object.keys(events).length > 0) &&
            events.map((event,i) => {
              return i+1 <= maxEventsCount ? (
                <>
                <Col lg={3} className="mb-3">
                  <CourseEvent coursedetails={{'course' : event}} itemType="booking_event" eventDetails={event} currentCurrency={currency} isCartEnabled={isCartEnabled} currentDateTime={currentDateTime} selectedTimeZone={selectedTimeZone} memberPricingLabel={memberPricingLabel} currentPricingLabel={currentPricingLabel} showMemberPrice={showMemberPrice} className="limited"/>
                </Col>
                </>
              ) : ''
            })
        }
        {/* <Col lg={3} className="mb-3">
          <CourseEvent className="limited"/>
        </Col>
        <Col lg={3} className="mb-3">
          <CourseEvent className="sold"/>
        </Col>
        <Col lg={3} className="mb-3">
          <CourseEvent className="limited"/>
        </Col>
        <Col lg={3} className="mb-3">
          <CourseEvent className="limited"/>
        </Col> */}
        {/* {events && events.length > 0 &&  */}
        { showSeeMoreDates && 
          <Col lg={12} className="text-center">
            <a href="javascript:void(0)" onClick={seeMoreDates} className="btn-more my-3 d-inline-block">See more dates</a>
          </Col>
        }
      </Row>
      <Row>
        <Col lg={{ span: 6, offset: 3 }} className="mk-training-description mb-5">
          {bbcDescription != '' && 
            <CourseBundleDescription className="mt-2 mb-4" courseBundleDescTitle="Description" courseBundleDesc={bbcDescription} />
          }
          {
            Object.keys(customSections).length > 0 && 
            Object.keys(customSections).map((key) => {
              return <CourseBundleDescription className="mt-2 mb-4" courseBundleDescTitle={customSections[key].name} courseBundleDesc={customSections[key].description} />
            })
          }
          {striptags(bbcRefundPolicy).trim() != '' && 
            <CourseBundleDescription className="mt-2 mb-4" courseBundleDescTitle="Refund Policy" courseBundleDesc={bbcRefundPolicy} />
          }
          {striptags(bbcCancellationPolicy).trim() != '' && 
            <CourseBundleDescription className="mt-2 mb-4" courseBundleDescTitle="Cancellation Policy" courseBundleDesc={bbcCancellationPolicy} />
          }
        </Col>
      </Row>
    </>
  );
}

export default CourseEventsListing;